// extracted by mini-css-extract-plugin
export var parcelRow = "_si-0";